export function LoanCarActivateCtrl (
	$scope,
	$window,
	companyApi,
	settings
) {

  $scope.settings = settings;
  $scope.Company = companyApi;

  $scope.subscriptionUpgrade = function () {
    return $window.location.href = '#/subscription_type_upgrade';
  };
}